import apiClient from "@/utils/axios.js";
import { useAuthStore } from "@/stores/auth-store.js";

export const getCsrfToken = async() => {
	const token = document.querySelector('meta[name="csrf-token"]');
	let content = (await apiClient.get('/csrf-token')).data.token;
	token.content = content;
	
	window.Echo.disconnect();
	window.Echo.connect();
	
	useAuthStore().CSRF_UPDATING(false);
	
	return content;
};